let Pouch = require("pouchdb").default;
let db = new Pouch("exodus");
let _ = require('lodash');
import {generateId} from '@/validator';


export function signUserIn(username,password,fn){
                
 db.get('staff').then(function (dot) {
   
   let doc = JSON.parse(dot.staff);
                    
   for(let j = 0 ; j< doc.length ; j++){
              
    if(doc[j].name == username && doc[j].password == password){
                    
    let user = doc[j];
    
   return fn(user);
                
    }else if((j+1) == doc.length){
        
     return fn(false);
     
    }
                    
   }
        
        
   }).catch(function (err) {
     console.log(err);
        
    });
 
}

export function setup(username,password,name,gender,email,privilege,phone_no){

        const user = [];
        const staff = [{
         name:username,
         password:password,
         fullname:name,
         gender:gender,
         email:email,
         rights:['001','002','003','004','005','006','007','008','009','010','011','012','013','014','015','016','017','018','019','020','021','022','023','024','025'],
         phone_no:phone_no,
         campus:'all',
         dateadded:"26/12/2018",
         useradd:"Programmer"
         
            
         }];
        
         //The following below when inserted it will have null automatically as its first index
        
        const setting = [];
        const movie = [];
        const category = [];
        const refreshment = [];
        const campus = [];
        const ticket = [];
        const watch = [];
        
        
        // this ends here
        
        let doc1,doc2,doc3,doc4,doc5,doc6,doc7,doc8,doc9,docs;
        
        //Preparing the documents array
        doc1 = {_id: 'user', user:JSON.stringify(user)};
        doc2 = {_id: 'staff', staff:JSON.stringify(staff)};
        doc3 = {_id: 'movie', movie:JSON.stringify(movie)};
        doc4 = {_id: 'category', category:JSON.stringify(category)};
        doc5 = {_id: 'refreshment', refreshment:JSON.stringify(refreshment)};
        doc6 = {_id: 'campus', campus:JSON.stringify(campus)};
        doc7 = {_id: 'ticket', ticket:JSON.stringify(ticket)};
        doc8 = {_id: 'watch', watch:JSON.stringify(watch)};
        doc9 = {_id: 'setting', setting:JSON.stringify(setting)};
        
        
        docs = [doc1, doc2, doc3,doc4,doc5,doc6,doc7,doc8,doc9];
        //Inserting Documents
            
        
db.get('staff', function(err, doc) {
    
    if (err){
    console.log('Error is : '+err.status);
    
    db.bulkDocs(docs, function(err, response) {
        
        if (err){
        
            
            console.log('Error,pls try again later','Error');
            console.log(err);
                } else {
        
        
            console.log('Successfully created your account');
            console.log(response);
                    
        }
        
        });
    } else{
    console.log(doc);
    }
    });
        
        
        
        
        
    
}

export function reset(module,fn){
    //This resets a specific id/module in pouchdb to []
    //i.e it could reset staff,tickets etc to []
    db.get(module).then(function (doc) {
        
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
                
                fn(100);
        }else{
            
            var just =  [] ;
            doc[module] = JSON.stringify(just);  
            fn(200);
           
        
        
        }
        
        if(db.put(doc)){
        console.log (doc);
            
        }else{
            console.log("an error occured");    
        }
        
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        fn(400)
        
                            }
        }); 
        
        
        
    
}

export function drop(){
db.destroy(function(err){
    if(err){
        console.log(err);
    }else{
        console.log("Database Deleted");
    }
})
}


export function getAttachment(id,spe_id,fn){
    db.getAttachment(id, spe_id, function(err, blob_buffer) {
        if (err) {
            return fn({});
        } else{
           let  result = URL.createObjectURL(blob_buffer);
           return fn(result);
        
        }
        });
}

export function addModule(module,itemname,newitem,fn){
        
        db.get(module).then(function (doc) {
        let just; 
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
            just =  JSON.parse(doc[module]) ;
            console.log(just.push(newitem));
            console.log(just);
            doc[module] = JSON.stringify(just);  
            
        }else{
            
           let length = JSON.parse(doc[module]).length;
           console.log(JSON.parse(doc[module]));
           for (let i=0; i< length;i++){
        
              if(JSON.parse(doc[module])[i].name == itemname){
                  alert("That name has been taken","Exodus");
                  return fn(false);
          }
            else if((i+1) == length){
            
            just =  JSON.parse(doc[module]) ;
            just.push(newitem);
            console.log(just);
            doc[module] = JSON.stringify(just);  
             
            }
        }
        
        }
        
       db.put(doc).then(function(){
            return fn(just);

                });
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false);
        
                            }
        }); 
        
        
        
}


export function editModule(module,olditemname,itemname,newitem,fn){

    db.get(module).then(function (doc) {
  
    var length = JSON.parse(doc[module]).length;
    console.log(JSON.parse(doc[module]));
    for (var i=0; i< length;i++){
 
   if(JSON.parse(doc[module])[i].name == itemname){
    if(!(olditemname == itemname)){
        if(module == 'refreshment'){
            alert('A refreshment with the new name you intend to store already exist,please enter another name','Exodus');
            
        }else if(module == 'staff'){
            alert('A staff with the new username you intend to store already exist,please enter another username','Exodus');
            
        }else{
            alert('A staff with the new username you intend to store already exist,please enter another username','Exodus');
            
        }
        return fn(false);
    }
    
  }
}


            
           deleteModule(module,olditemname,function(response){
                    if(response){
                        addModule(module,itemname,newitem,function(response){
                            if(response){
                               return fn(true);
                           }else{
                                return fn(false);
                            }
          
                         })
                    }else{
                        return fn(false)
                    }
           }) 
                      

    },function (err) {
         console.log(err);
         if(err.name=='not_found'){
         console.log(err);
         return fn(false);
     }
        });


}

export function deleteModule(module,olditemname,fn){
 
    
    db.get(module).then(function (doc) {
        
         let updatearray = JSON.parse(doc[module]);
         let length = updatearray.length;
            
         for (let i=0; i< length;i++){
          console.log((i+1)+"). ","Oldname in db: "+updatearray[i].name+" Supplied: "+olditemname);
                
          if(updatearray[i].name == olditemname){
            
           if(!(_.remove(updatearray, { name: olditemname }))){
               console.log("Lodash is not working");
               return fn(false)
           }
            console.log(updatearray);
            doc[module] = JSON.stringify(updatearray);  
            break;
        
          }
          
            
        }
        
         db.put(doc).then(function(){
            return fn(true);

                });
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false)
        
                            }
        }); 
        
        
        
        
}

export function getModule(module,fn){
    
    
    db.get(module).then(function (doc) {
    
    
    if(JSON.parse(doc[module])[0] == null){
        let result= {
            data:[],
            status:200
        };
        
        fn(result);
    }else{
        
          let value = JSON.parse(doc[module]);
          
          let result= {
            data:value,
            status:200
          };
     fn(result);
    }
    
    },function (err) {
    
    console.log('Error: ',err);
    
    if(err.name=='not_found'){
    
    console.log(err);
    
    fn({status:400})
    
                        }
    }); 
    
    
    }
   
   

    //Module for attchments
    export function addModuleWithAttachment(module,modules,itemname,newitem,file,fn){
        
        let check = false;
        db.get(module).then(function (doc) {
        
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
                console.log(JSON.parse(doc[module]));
                doc[module] = JSON.stringify([newitem]);
                //fn(true);
        }else{
            
            var length = JSON.parse(doc[module]).length;
           console.log(JSON.parse(doc[module]));
        for (var i=0; i< length;i++){
        
          if(JSON.parse(doc[module])[i].name == itemname){
            alert('Sorry,the '+ module +' already exist');
            check = true;
            return fn(false);
            
          }
            else if((i+1) == length){
            
            var just =  JSON.parse(doc[module]) ;
            just.push(newitem);
            console.log(just);
            doc[module] = JSON.stringify(just);  
             
            //fn(true);
            }
        }
        
        }
        
        db.put(doc).then(function(){
            let rev;
            console.log("rev ",doc._rev);
            db.get(module).then(function(doc){
                console.log(doc._rev);
                rev = doc._rev;
                if(check==false){
                    console.log('dddc ',rev);
                    db.putAttachment(module,itemname,rev, file, file.type, 
                    function(err, res) {
                         if (err) {
                            console.log("An error",err);
                              return fn(false); 
                              
                            } else {
                                 console.log (res+"Attachment added successfully"); 
                                 return fn(true);
                                }
                             });
                         }
            });
        });
            
                
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false)
        
                            }
        }); 
        
        
        }
        
export function editModuleWithAttachment(module,olditemname,itemname,newitem,file,fn){

    db.get(module).then(function (doc) {
  
    var length = JSON.parse(doc[module]).length;
    console.log(JSON.parse(doc[module]));
    for (var i=0; i< length;i++){
 
   if(JSON.parse(doc[module])[i].name == itemname){
    if(!(olditemname == itemname)){
        if(module == 'category'){
            alert('A category with the new name you intend to store already exist,please enter another name','Exodus');
            return fn(false);
        
        }else if(module == 'campus'){
            alert('A campus with the new name you intend to store already exist,please enter another name','Exodus');
            return fn(false);
        }else{
            console.log(olditemname,'   ',itemname);
            alert('A movie with the new name you intend to store already exist,please enter another name','Exodus');
            return fn(false);
        }
         }
   }
}

            
           deleteModuleWithAttachment(module,olditemname,function(response){
                    if(response){
                        addModuleWithAttachment(module,'categories',itemname,newitem,file,function(response){
                            if(response){
                                fn(true);
                           }else{
                                fn(false);
                            }
          
                         })
                    }else{
                        fn(false)
                    }
           }) 
                      
    },function (err) {
         console.log(err);
         if(err.name=='not_found'){
         console.log(err);
         fn(false);
     }
        });
  }

export function deleteModuleWithAttachment(module,olditemname,fn){
    
    
    db.get(module).then(function (doc) {
    
        let updatearray = JSON.parse(doc[module]);
    
        let length = updatearray.length;
        
     for (let i=0; i< length;i++){
      console.log((i+1)+"). ","Oldname in db: "+updatearray[i].name+" Supplied: "+olditemname);
            
      if(updatearray[i].name == olditemname){
        
       if(!(_.remove(updatearray, { name: olditemname }))){
           console.log("Lodash is not working");
           fn(false)
       }
        console.log(updatearray);
        doc[module] = JSON.stringify(updatearray);  
        break;
    
      }
      
        
    }
    
    db.put(doc).then(function(){
        let rev = doc._rev;
            console.log('Old Rev: ',rev);
            db.get(module).then(function(doc){
                console.log('Current Rev: ',doc._rev);
                rev = doc._rev;
                console.log("Rev used: ",rev);
                db.removeAttachment(module, olditemname, rev, function(err, res) {
                    console.log("Module: ",module," OldItemname ",olditemname);
                    if (err) {
                        fn(true);
                        console.log(err);
                        }
                        else {
                        console.log(res+"Attachment Deleted successfully");
                        fn(true);
                        }
               });
       
            }); 
            });
    },function (err) {
    
    console.log(err);
    
    if(err.name=='not_found'){
    
    console.log(err);
    
    fn(false)
    
                        }
    }); 
    
    
    
    
}
export function  editCorrespend(module,mod_par_old,mod_par_new,cor_mod_par,fn){
   
    db.get(module).then(function (doc) {
        let just; 
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
            fn(true);

        }else{
            
           let length = JSON.parse(doc[module]).length;
           just = JSON.parse(doc[module]);
           for (let i=0; i< length;i++){
            if(just[i][cor_mod_par] === mod_par_old ){
                just[i][cor_mod_par] = mod_par_new;
                if(cor_mod_par == 'category'){
                just[i].name = (just[i].movName+mod_par_new).toLowerCase();
                }
            }
            if((i+1) == length){
            
            doc[module] = JSON.stringify(just);  
             
            }
        }
        
        }
        
        if(db.put(doc)){
        console.log (doc);
        return fn(just);  
        }else{
            console.log("Error");
        }
        
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false);
        
                            }
        }); 
        
    }

    export function deleteCorrespend(module,mod_par,cor_mod_par,fn){
        
        let updatearray;
    db.get(module).then(function (doc) {
                
        if(JSON.parse(doc[module])[0] == null){
            
            fn(true);

        }else{
           
            updatearray = JSON.parse(doc[module]);
           let length = updatearray.length;
           let olditemarr = [];
           for (let i=0; i< length;i++){
            if(updatearray[i][cor_mod_par] === mod_par ){

                olditemarr[i] = updatearray[i].name;
                console.log(mod_par);
                console.log(updatearray[i][cor_mod_par]);
                console.log((i+1),'len: ',length);
                
            }
              //this is tye pronlr,
            if(((i+1) == length) && (olditemarr[0] == null)){
                fn(true);
        }else if((i+1) == length){
            deleteModuleWithAttachmentArray(module,olditemarr,function(res){
            console.log(res);
            fn(true);
        });
    }    
            }
            
        console.log(4);
        
        }
        
              
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false);
        
                            }
        }); 
    }
    
    export function addSubModule(module,campname,itemname,newitem,fn){
        let just;
        db.get(module).then(function (doc) {
         
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
            return fn({err:'not_found',value:false});
        }else{
            
           let length = JSON.parse(doc[module]).length;
           console.log(JSON.parse(doc[module]));
           console.log('I am length : ',length);
           for (let i=0; i< length;i++){
           console.log(JSON.parse(doc[module])[i].name,'  l ', campname);
              if(JSON.parse(doc[module])[i].name == campname){
                  let movie = JSON.parse(doc[module])[i].movies;
                  let movlen = movie.length;
                  if(movie[0] == null){
                    
                    just =  JSON.parse(doc[module]) ;
                    console.log(just[i].movies.push(newitem));
                    console.log(just);
                    doc[module] = JSON.stringify(just);  
               

                  }else{
                    console.log("Inside else ");
                  for(let j=0; j< movlen; j++){
                    console.log(movie[j].name,'  l ', itemname);
                    
                    if(movie[j].name == itemname){
                        return fn({err:'name',value:false});

                    }else if((j+1) == movlen){
                        
                        just =  JSON.parse(doc[module]) ;
                        just[i].movies.push(newitem);
                        console.log(just);
                        doc[module] = JSON.stringify(just);  
                   
                    
                    }
                }
          }
          
        }
        
        }
    }
        if(db.put(doc)){
        console.log (doc);
        return fn({data:just,value:true});  
        }else{
            console.log("Error");
        }
        
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn({err:'Not found o',value:false});
        
                            }
        }); 
        
        
    }

    export function deleteSubModule(module,campname,itemname,fn){
        let just;
        db.get(module).then(function (doc) {
         
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
            
            return fn({err:'not_found',value:false});
        }else{
            
           let length = JSON.parse(doc[module]).length;
           console.log(JSON.parse(doc[module]));
           console.log('I am length : ',length);
           for (let i=0; i< length;i++){
           console.log(JSON.parse(doc[module])[i].name,'  l ', campname);
              if(JSON.parse(doc[module])[i].name == campname){
                  let movie = JSON.parse(doc[module])[i].movies;
                  let movlen = movie.length;
                  if(movie[0] == null){
                    
                  return fn({value:true});

                  }else{
                    console.log("Inside else ");
                  for(let j=0; j< movlen; j++){
                    console.log(movie[j].name,'  l ', itemname);
                    
                    if(movie[j].name == itemname){
                       
                       just = JSON.parse(doc[module]);
                       let updatearray = just[i].movies ;
                        if(!(_.remove(updatearray, { name: itemname }))){
                            console.log("Lodash is not working");
                            return fn({err:'An error occured, try agian later',value:false});
                            
                        }
                         doc[module] = JSON.stringify(just);  
                         break;

                    }else if((j+1) == movlen){
                        return fn({value:true});              
                    
                    }
                }
          }
          
        }
        
        }
    }
        if(db.put(doc)){
        console.log (doc);
        return fn({data:just,value:true});  
        }else{
            console.log("Error");
            return fn({err:'Error! Please try again later.',value:false});
            
           
        }
        
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn({err:'Error!',value:false});
        
                            }
        }); 
        
        
    }

export function sellModule(module,campname,submod,itemname,p,quantity,fn){
            //call the addModule to add to tickets(using a for loop)
            // when this id done it will then
            //insert the campus doc back, this will have the new slots represented
            let just,totSold = []; 
            db.get(module).then(function (doc) {
             
            console.log(doc[module]);
            
            if(JSON.parse(doc[module])[0] == null){
                
                return fn({err:'not_found',value:false});
            }else{
                
               let length = JSON.parse(doc[module]).length;
               console.log(JSON.parse(doc[module]));
               console.log('I am length : ',length);
               for (let i=0; i< length;i++){
               console.log(JSON.parse(doc[module])[i].name,'  l ', campname);
                  if(JSON.parse(doc[module])[i].name == campname){
                      let movie = JSON.parse(doc[module])[i].movies;
                      let movlen = movie.length;
                      if(movie[0] == null){
                        
                      return fn({err:'not_found',value:false});
    
                      }else{
                        console.log("Inside else ");
                      for(let j=0; j< movlen; j++){
                        console.log(movie[j].name,'  l ', itemname);
                        
                        if(movie[j].name == itemname){
                           
                           just = JSON.parse(doc[module]);
                           let updatearray = just[i].movies[j] ;
                           let slots = updatearray.slots;
                           if(slots < quantity){
                            return fn({err:'under',value:false});
                            
                           }
                           let remSlot = Number(slots-(quantity));
                           for(let k=0;k<quantity;k++){
                            p.name = generateId(campname);
                            totSold[k]={name:p.name,type:p.type,mov_name:p.mov_name,category:p.category,price:p.price,vDate:p.vDate,vTime:p.vTime,dateadded:p.dateadded,usersold:p.usersold};
                                                     
                            if((k+1) == quantity){
                                console.log(totSold);
                                addModuleArray('ticket',totSold,function(res){
                                    if(res){
                                        
                                        just[i].movies[j].slots = remSlot;
                                           
                                            doc[module] = JSON.stringify(just);  
                                            if(db.put(doc)){
                                                console.log (doc);
                                                return fn({data:totSold,value:true});  
                                                }else{
                                                    console.log("Error");
                                                    return fn({err:'Error! Please try again later.',value:false});
                                                    
                                                   
                                                }
                                      
                                    }else{
                                        console.log("Error");
                                        return fn({err:'Error! Please try again later.',value:false});
                                        
                                    }
                                });
                            }
                            
                           
                           }
                          
                        }else if((j+1) == movlen){
                            return fn({err:'not_found',value:false});
                            
                        }
                    }
              }
              
            }
            
            }
        }
            
            
            },function (err) {
            
            console.log(err);
            
            if(err.name=='not_found'){
            
            console.log(err);
            
            return fn({err:'Error!',value:false});
            
                                }
            }); 
            
               
}

function addModuleArray(module,array,fn){
    console.log(array);
    db.get(module).then(function (doc) {
        let just; 
        console.log(doc[module]);
        
        if(JSON.parse(doc[module])[0] == null){
           console.log('Inside addModArr for loop');
           just =  JSON.parse(doc[module]) ;
           
           for(let i=0;i<array.length;i++){
            just.push(array[i]);
           
           } 
            doc[module] = JSON.stringify(just);  
            
        }else{
            
           let length = JSON.parse(doc[module]).length;
           console.log(JSON.parse(doc[module]));
           just =  JSON.parse(doc[module]) ;
           for (let j=0; j< array.length;j++){
            for (let i=0; i< length;i++){
                
                      if(JSON.parse(doc[module])[i].name == array[j].name){
                          console.log(false);
                          break;
                  }
                    else if((i+1) == length){
                    
                    just.push(array[j]);
                     
                    }
                }
                 if((j+1) == array.length){
                    
                    doc[module] = JSON.stringify(just);  
                     
                    }
           }
           
        
        }
        
        if(db.put(doc)){
        console.log (doc);
        return fn(just);  
        }else{
            console.log("Error");
        }
        
        },function (err) {
        
        console.log(err);
        
        if(err.name=='not_found'){
        
        console.log(err);
        
        return fn(false);
        
                            }
        }); 
        
        
        

}

export function getLinkedCat(module,param,param_val,fn) {
    db.get(module).then(function (doc) {
    if(JSON.parse(doc[module])[0] == null){
        
        return fn({value:false});
    }else{
        
       let length = JSON.parse(doc[module]).length;
       for (let i=0; i< length;i++){
              let movie = JSON.parse(doc[module])[i].movies;
              let movlen = movie.length;
              if(!(movie[0] == null)){
                console.log("Inside else ");
                for(let j=0; j< movlen; j++){
                  
                  if(movie[j][param] == param_val){
                      return fn({value:true});
  
                  }
              }
              }
               if((i+1) == length){
                
               return fn({value:false});
            }
       
    }
}
   },function (err) {
    
    console.log(err);
    
    if(err.name=='not_found'){
    
    console.log(err);
    
    return fn({err:'Not found o',value:false});
    
                        }
    }); 
    
   
}

export function getLinkedMov(module,param1,param_val1,param2,param_val2,fn) {
    db.get(module).then(function (doc) {
     
    console.log(doc[module]);
    
    if(JSON.parse(doc[module])[0] == null){
        
        return fn({value:false});
    }else{
        
       let length = JSON.parse(doc[module]).length;
       console.log(JSON.parse(doc[module]));
       console.log('I am length : ',length);
       for (let i=0; i< length;i++){
              let movie = JSON.parse(doc[module])[i].movies;
              let movlen = movie.length;
              if(!(movie[0] == null)){
                console.log("Inside else ");
                console.log('I am length : ',movlen);
                
                for(let j=0; j< movlen; j++){
                    console.log("I am J: ",j," and i am i: ",i);
                  console.log(movie[j][param1],' ', param_val1,' ',movie[j][param2],' ', param_val2);
                  if((movie[j][param1] == param_val1 ) && (movie[j][param2] == param_val2 )){
                      return fn({value:true});
  
                  }
              }
              }
               if((i+1) == length){
                
              return fn({value:false});
            }
       
    }
}
    
    
    },function (err) {
    
    console.log(err);
    
    if(err.name=='not_found'){
    
    console.log(err);
    
    return fn({err:'Not found o',value:false});
    
                        }
    }); 
    
   
}

export function deleteModuleWithAttachmentArray(module,array,fn){
    
    
    db.get(module).then(function (doc) {
    
        let updatearray = JSON.parse(doc[module]);
        console.log(updatearray);
    
         for (let i=0; i< JSON.parse(doc[module]).length;i++){
           for(let j=0;j<array.length;j++){
               console.log('I is: ',i,' k => ',JSON.parse(doc[module])[i]);
                if(JSON.parse(doc[module])[i].name == array[j]){
                    
                   if(!(_.remove(updatearray, { name: array[j] }))){
                       console.log("Lodash is not working");
                       fn(false)
                   }
                    break;
                
                  }
            }
     
      if((i+1) == JSON.parse(doc[module]).length){
        console.log(updatearray);
        doc[module] = JSON.stringify(updatearray);  
       
      }
        
    }
    
    db.put(doc).then(function(){
        let rev = doc._rev;
            console.log('Old Rev: ',rev);
            db.get(module).then(function(doc){
                console.log('Current Rev: ',doc._rev);
                rev = doc._rev;
                console.log("Rev used: ",rev);
                for(let j=0;j<array.length;j++){
                    db.removeAttachment(module, array[j], rev, function(err, res) {
                        console.log("Module: ",module," OldItemname ",array[j]);
                        if (err) {
                            if((j+1) == array.length){
                                
                                console.log(err);
                               return  fn(true);
                            }
                            
                            }
                            else {
                                if((j+1) == array.length){
                                    console.log(res+"Attachment Deleted successfully");
                                    return fn(true);   
                                                                }
                            
                            }
                   });
                }          
               
       
            }); 
            });
    },function (err) {
    
    console.log(err);
    
    if(err.name=='not_found'){
    
    console.log(err);
    
    fn(false)
    
                        }
    }); 
    
    
    
    
}
